import { ICanvasElement } from '@/interface/canvas';
import { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

function MobileInput({
  style,
  code,
  setFieldValue,
  inputClassName,
  containerClassName,
}: MobileInputProps) {
  const [countryCode, setCountryCode] = useState(code);

  useEffect(() => {
    let newCode = code;
    if (code) {
      if (!code.includes('+')) {
        newCode = '+' + code;
      }
    }
    setCountryCode(newCode);
  }, []);
  return (
    <PhoneInput
      value={code ? countryCode : '+91'}
      placeholder="Mobile Number"
      onChange={value => {
        const num = '+' + value;
        setFieldValue('mobile_number', num);
      }}
      disableDropdown={code ? true : false}
      countryCodeEditable={!code}
      containerStyle={{
        color: style?.color,
        width: 'full',
        height: '100%',
      }}
      dropdownClass="scrollbar"
      inputStyle={{
        backgroundColor: 'transparent',
        color: style?.color || '#606060',
        width: '100%',
        height: 'inherit',
        borderColor: style?.border_color,
        borderWidth: 0,
        borderStyle: style?.border_style,
        borderRadius: style?.border_radius,
        opacity: style?.opacity,
        fontSize: '16px',
      }}
      buttonStyle={{
        backgroundColor: style?.background_color,
        background: 'transparent',
        borderColor: style?.border_color,
        borderStyle: style?.border_style,
        borderRadius: style?.border_radius,
        opacity: style?.opacity,
      }}
      dropdownStyle={{
        backgroundColor: '#fff',
        width: '250px',
        borderRadius: '7px',
        overflow: 'auto',
        maxHeight: '180px',
      }}
      searchStyle={{ color: 'gray' }}
      inputProps={{ autoComplete: 'none' }}
      inputClass={inputClassName}
      containerClass={containerClassName}
    />
  );
}
type MobileInputProps = {
  style?: ICanvasElement;
  setFieldValue: any;
  code?: string;
  inputClassName?: string;
  containerClassName?: string;
};
export default MobileInput;
